@if (!isHidden) {
	<div [ngClass]="{ required: input.required }" [formGroup]="form()">
		@switch (input.type) {
			@case ("text") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					@if (input.focus) {
						<input
							stagesTrim
							[type]="input.inputFieldType"
							[id]="input.key"
							class="text fullsize"
							[formControlName]="input.key"
							[readonly]="input.readonly"
							[attr.disabled]="input.disabled ? 'disabled' : null"
							(focus)="input.expand ? input.expand() : nop()"
							stagesAutofocus
						/>
					}
					@if (!input.focus) {
						<input
							stagesTrim
							[type]="input.inputFieldType"
							[id]="input.key"
							class="text fullsize"
							[formControlName]="input.key"
							[readonly]="input.readonly"
							[attr.disabled]="input.disabled ? 'disabled' : null"
							(focus)="input.expand ? input.expand() : nop()"
							(change)="onValueChange(input)"
						/>
					}
					<div class="info">
						@if (input.infoMsgKey && !hasErrors(formControl)) {
							<div class="info-message" [translate]="input.infoMsgKey"></div>
						}
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									@switch (error) {
										@case ("required") {
											<div class="error" translate="input.required" role="alert"></div>
										}
										@case ("maxlength") {
											<div
												class="error"
												translate="input.maxLength"
												[translateParams]="{ length: input.maxLength }"
												role="alert"
											></div>
										}
										@default {
											<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
										}
									}
								}
							</div>
						}
						@if (input.maxLength) {
							<div class="maxlength">{{ getInputLength() }}/{{ input.maxLength }}</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("checkbox") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<input
						[type]="input.inputFieldType"
						hidden="hidden"
						[formControlName]="input.key"
						[checked]="formControl.value"
					[attr.aria-label]="input.key"
		/>
					<!--	if we use a custom toogle function the default input brwoser behaviour is overwritten	-->
					<!--	and the disabled attribute is not working	-->
					<!--	nevertheless with some magic the disabled attribute is somehow added to the input element (maybe from the dormControl?!	-->
					<!--	the line below was the try with the disabled attribute	-->
					<!--		[attr.disabled]="input.disabled ? 'disabled' : null"   -->
					<label [for]="input.key" class="switch" (click)="toggleCheckbox()"></label>
					<div class="info">
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
						@if (input.warnMsgKey) {
							<div class="warning-color">
								<p><span class="ico ico-warning ico-inline"></span> {{ input.warnMsgKey | translate }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("radio") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					@for (
						option of selectionOptions | orderAlphabetically: getOptionLabel : isAlphabeticallyOrderedSelection();
						track option
					) {
						<div class="radio">
							<input
								[id]="option.value"
								[type]="input.inputFieldType"
								[formControlName]="input.key"
								[value]="option.value"
								[checked]="formControl.value === option.value"
								(change)="onValueChange(input)"
								[name]="input.key"
								[attr.disabled]="input.disabled ? 'disabled' : null"
							/>
							<label [for]="option.value" (click)="selectRadioChoice(option.value)">{{ option.value }}</label>
						</div>
					}
					<div class="info">
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
						@if (input.warnMsgKey) {
							<div class="warning-color">
								<p><span class="ico ico-warning ico-inline"></span> {{ input.warnMsgKey | translate }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("selection") {
				<div [ngClass]="{ required: input.required }">
					@if (!hideLabel()) {
						<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					}
					<select
						[id]="input.key"
						[formControlName]="input.key"
						class="fullsize nowrap"
						[size]="size"
						[multiple]="isMultiSelect()"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						(change)="onValueChange(input)"
			[attr.aria-label]="hideLabel() ? input.key : null"
					>
						@for (
							option of selectionOptions | orderAlphabetically: getOptionLabel : isAlphabeticallyOrderedSelection();
							track option
						) {
							<option [value]="option.value">
								{{ getOptionLabel(option) }}
							</option>
						}
					</select>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									<ng-container role="alert">
										@switch (error) {
											@case ("required") {
												<div class="error" translate="input.required" role="alert"></div>
											}
										}
									</ng-container>
								}
							</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
						@if (input.infoMsgKey && !hasErrors(formControl)) {
							<div class="info-message" [translate]="input.infoMsgKey"></div>
						}
					</div>
				</div>
			}
			@case ("password") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<input
						[type]="input.inputFieldType"
						[id]="input.key"
						class="text fullsize"
						[formControlName]="input.key"
						[readonly]="input.readonly"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						autocomplete="new-password"
					/>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									<ng-container role="alert">
										@switch (error) {
											@case ("required") {
												<div class="error" translate="input.required" role="alert"></div>
											}
											@case ("maxlength") {
												<div
													class="error"
													translate="input.maxLength"
													[translateParams]="{ length: input.maxLength }"
													role="alert"
												></div>
											}
											@default {
												<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
											}
										}
									</ng-container>
								}
							</div>
						}
						@if (input.maxLength) {
							<div class="maxlength">{{ getInputLength() }}/{{ input.maxLength }}</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("textarea") {
				<div>
					@if (!hideLabel()) {
						<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					}
					@if (input.placeholderKey) {
						<textarea
							stagesTrim
							[id]="input.key"
							class="text plaintext-input"
							[formControlName]="input.key"
							[readonly]="input.readonly"
							[attr.disabled]="input.disabled ? 'disabled' : null"
							[placeholder]="input.placeholderKey | translate"
							stagesAutoGrow
			[attr.aria-label]="hideLabel() ? fieldLabel : null"
						>
						</textarea>
					}
					@if (!input.placeholderKey || input.placeholderKey === undefined) {
						<textarea
							stagesTrim
							[id]="input.key"
							class="text plaintext-input"
							[formControlName]="input.key"
							[readonly]="input.readonly"
							[attr.disabled]="input.disabled ? 'disabled' : null"
							stagesAutoGrow
			[attr.aria-label]="hideLabel() ? fieldLabel : null"
						>
						</textarea>
					}
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									<ng-container role="alert">
										@switch (error) {
											@case ("required") {
												<div class="error" translate="input.required" role="alert"></div>
											}
											@case ("maxlength") {
												<div
													class="error"
													translate="input.maxLength"
													[translateParams]="{ length: input.maxLength }"
													role="alert"
												></div>
											}
											@default {
												<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
											}
										}
									</ng-container>
								}
							</div>
						}
						@if (input.maxLength) {
							<div class="maxlength">{{ getInputLength() }}/{{ input.maxLength }}</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("json") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<textarea
						[id]="input.key"
						class="text plaintext-input"
						[formControlName]="input.key"
						[readonly]="input.readonly"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						stagesAutoGrow
					>
					</textarea>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									<ng-container role="alert">
										@switch (error) {
											@case ("required") {
												<div class="error" translate="input.required" role="alert"></div>
											}
											@case ("maxlength") {
												<div
													class="error"
													translate="input.maxLength"
													[translateParams]="{ length: input.maxLength }"
													role="alert"
												></div>
											}
											@case ("json") {
												<div class="error" translate="input.notValid" role="alert"></div>
											}
											@default {
												<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
											}
										}
									</ng-container>
								}
							</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("number") {
				<div class="form-wrapper" appInvalidControlScrollContainer>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<input
						[type]="input.inputFieldType"
						[id]="input.key"
						class="text fullsize"
						[formControlName]="input.key"
						[readonly]="input.readonly"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						(change)="onValueChange(input)"
						stagesValidateOnBlur
					/>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									<ng-container role="alert">
										@switch (error) {
											@case ("required") {
												<div class="error" translate="input.required" role="alert"></div>
											}
											@case ("integer") {
												<div class="error" translate="input.integer" role="alert"></div>
											}
											@case ("min") {
												<div class="error" translate="input.minNumber" role="alert"></div>
											}
											@case ("max") {
												<div class="error" translate="input.maxNumber" role="alert"></div>
											}
											@default {
												<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
											}
										}
									</ng-container>
								}
							</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("date") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<input
						[type]="input.inputFieldType"
						[id]="input.key"
						class="text fullsize"
						[formControlName]="input.key"
						[readonly]="input.readonly"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						(change)="onValueChange(input)"
					/>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									@switch (error) {
										@case ("required") {
											<div class="error" translate="input.required" role="alert"></div>
										}
										@case ("date") {
											<div
												class="error"
												translate="input.pattern.date"
												[translateParams]="{ format: 'yyyy-MM-dd' }"
												role="alert"
											></div>
										}
										@default {
											<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
										}
									}
								}
							</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("ids") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<input
						[type]="input.inputFieldType"
						[id]="input.key"
						class="text fullsize"
						[formControlName]="input.key"
						[readonly]="input.readonly"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						(change)="onValueChange(input)"
					/>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									@switch (error) {
										@case ("required") {
											<div class="error" translate="input.required" role="alert"></div>
										}
										@case ("ids") {
											<div class="error" translate="input.ids" role="alert"></div>
										}
										@default {
											<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
										}
									}
								}
							</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("rich_text") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<stages-description-editor
						#descriptionComp
						[formControlName]="input.key"
						[editorId]="input.key"
						[modifiable]="!input.readonly"
						[unsafe]="false"
						[processTypeIdent]="richtextInput.processTypeIdent!"
						[pluginRegistry]="richtextInput.pluginRegistry"
						[workspaceId]="richtextInput.workspaceId"
						[beanType]="richtextInput.beanType ?? 'process'"
						[beanId]="richtextInput.beanId"
						[beanIdentity]="richtextInput.beanIdentity"
						[properties]="richtextInput.properties"
						[pv]="richtextInput.pv"
						[focus]="richtextInput.focus"
						[deactivateFloatingButton]="richtextInput.deactivateFloatingButton"
					>
					</stages-description-editor>
					<div class="info"></div>
				</div>
			}
			@case ("duration") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<div class="duration-input">
						<div>
							<input
								stagesTrim
								type="number"
								[id]="input.key"
								class="text duration-value"
								[formControlName]="input.key"
								[readonly]="!!$any(input).enabledKey && form().get($any(input).enabledKey)!.value === false"
								[attr.disabled]="input.disabled ? 'disabled' : null"
								(change)="onValueChange(input)"
							/>
							<select
								[id]="$any(input).unitKey"
								[formControlName]="$any(input).unitKey"
								[multiple]="false"
								[attr.disabled]="input.disabled ? 'disabled' : null"
								class="duration-unit"
					[attr.aria-labelledby]="input.key"
							>
								@for (option of selectionOptions; track option) {
									<option [value]="option.value">
										{{ getOptionLabel(option) }}
									</option>
								}
							</select>
						</div>
						@if (!!$any(input).enabledKey) {
							<input
								type="checkbox"
								hidden="hidden"
								[formControlName]="$any(input).enabledKey"
								class="duration-enabled"
								[name]="$any(input).enabledKey"
								[id]="$any(input).enabledKey"
								(change)="
									$any(input).setDisabled(
										formControl,
										form().get($any(input).unitKey)!,
										form().get($any(input).enabledKey)!
									)
								"
							/>
							<label [for]="$any(input).enabledKey" class="switch"></label>
						}
					</div>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									<ng-container role="alert">
										@switch (error) {
											@case ("required") {
												<div class="error" translate="input.required" role="alert"></div>
											}
											@case ("integer") {
												<div class="error" translate="input.integer" role="alert"></div>
											}
											@case ("min") {
												<div class="error" translate="input.minNumber" role="alert"></div>
											}
											@case ("max") {
												<div class="error" translate="input.maxNumber" role="alert"></div>
											}
											@default {
												<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
											}
										}
									</ng-container>
								}
							</div>
						}
						@if (input.helpMessage) {
							<div class="help">
								<p>{{ input.helpMessage }}</p>
							</div>
						}
					</div>
				</div>
			}
			@case ("reminder") {
				<div [formGroup]="$any(input).form">
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<div class="reminder-list">
						@for (duration of $any(input).reminderFormArray.controls; track duration; let i = $index) {
							<div class="reminder-item" formArrayName="reminder">
								<div class="reminder-controls">
									<ng-container [formGroupName]="i">
										<div>
											<input
												stagesTrim
												type="number"
												class="text duration-value"
												formControlName="value"
												[readonly]="$any(input).getEnabledControl(i).value === false"
												[attr.disabled]="$any(input).getEnabledControl(i).value === false ? 'disabled' : null"
												(change)="onValueChange(input)"
								[attr.aria-label]="input.key"
											/>
											<select
												formControlName="unit"
												[multiple]="false"
												[attr.disabled]="$any(input).getEnabledControl(i).value === false ? 'disabled' : null"
												class="duration-unit"
								[attr.aria-label]="input.key"
											>
												@for (option of selectionOptions; track option) {
													<option [value]="option.value">
														{{ getOptionLabel(option) }}
													</option>
												}
											</select>
										</div>
										<div>
							<button
								type="button"
								(click)="$any(input).removeReminder(i)"
								class="button clickable trash"
								[title]="'delete' | translate"
								[attr.aria-labelledby]="'delete' | translate"
							>
												<i class="ico ico-delete"></i>
											</button>

							<!-- misuse of the id field with [id]="'enabled' + i". The label cannot be matched, so we need an
							aria-labelledby -->
											<input
												type="checkbox"
												hidden="hidden"
												class="duration-enabled"
												formControlName="enabled"
												[name]="'enabled' + i"
												[id]="'enabled' + i"
												(change)="$any(input).setDisabled(i)"
								[attr.aria-label]="fieldLabel"
											/>
											<label [for]="'enabled' + i" class="switch"></label>
										</div>
									</ng-container>
								</div>
								<div>
									@if (
										hasErrors($any(input).getValueControl(i)) &&
										($any(input).getValueControl(i).dirty || $any(input).getValueControl(i).touched)
									) {
										<div>
											@for (error of $any(input).getErrors($any(input).getValueControl(i)); track error) {
												<ng-container role="alert">
													@switch (error) {
														@case ("required") {
															<div class="error" translate="input.required" role="alert"></div>
														}
														@case ("number") {
															<div class="error" translate="input.integer" role="alert"></div>
														}
														@case ("min") {
															<div class="error" translate="input.minNumber" role="alert"></div>
														}
														@case ("max") {
															<div class="error" translate="input.maxNumber" role="alert"></div>
														}
														@default {
															<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
														}
													}
												</ng-container>
											}
										</div>
									}
								</div>
							</div>
						}
						<div class="buttons">
							<button type="button" class="flat" (click)="$any(input).addReminder()">add reminder</button>
						</div>
					</div>
				</div>
			}
			@case ("escalation") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<ng-container [formGroupName]="input.key">
						<div class="escalation-input">
							<div>
								<select
						[id]="input.key"
									formControlName="stakeholder"
									[multiple]="false"
									[attr.disabled]="input.disabled ? 'disabled' : null"
									class="escalation-stakeholder"
								>
									@for (option of $any(input).stakeholders; track option) {
										<option [value]="option.value">
											{{ getOptionLabel(option) }}
										</option>
									}
								</select>
								<select
						[id]="input.key"
									formControlName="frequency"
									[multiple]="false"
									[attr.disabled]="input.disabled ? 'disabled' : null"
									class="escalation-frequency"
								>
									@for (option of $any(input).frequencies; track option) {
										<option [value]="option.value">
											{{ getOptionLabel(option) }}
										</option>
									}
								</select>
							</div>
							<ng-container>
								<input
									type="checkbox"
									hidden="hidden"
									formControlName="enabled"
									[name]="input.key + 'enabled'"
									[id]="input.key + 'enabled'"
									class="duration-enabled"
									(change)="$any(input).setDisabled()"
						[attr.aria-label]="fieldLabel"
								/>
								<label [for]="input.key + 'enabled'" class="switch"></label>
							</ng-container>
						</div>
						<div class="info">
							@if (input.helpMessage) {
								<div class="help">
									<p>{{ input.helpMessage }}</p>
								</div>
							}
						</div>
					</ng-container>
				</div>
			}
			@case ("color") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<div class="color-input">
						<stages-color-picker
							[formControlName]="input.key"
							[required]="input.required!"
							[maxLengthOfInput]="input.maxLength!"
							[colorPalette]="$any(input).colorPalette"
							[orientation]="$any(input).orientation"
						></stages-color-picker>
					</div>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									@switch (error) {
										@case ("required") {
											<div class="error" [translate]="'input.required'" role="alert"></div>
										}
										@case ("maxlength") {
											<div
												class="error"
												[translate]="'input.maxLength'"
												[translateParams]="{ length: input.maxLength }"
												role="alert"
											></div>
										}
										@case ("pattern") {
											<div class="error" [translate]="'processrelease.states.edit.color.pattern'"></div>
										}
									}
								}
							</div>
						}
						@if (input.infoMsgKey && !hasErrors(formControl)) {
							<div class="info-message" [translate]="input.infoMsgKey"></div>
						}
					</div>
				</div>
			}
			@case ("date_time") {
				<div>
		@if ($any(input).oldVersion) {
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
							<input
								stagesTrim
								[type]="input.inputFieldType"
								[id]="input.key"
								class="text fullsize"
								[formControlName]="input.key"
								[readonly]="input.readonly"
								[attr.disabled]="input.disabled ? 'disabled' : null"
								(focus)="input.expand ? input.expand() : nop()"
								(change)="onValueChange(input)"
								[attr.step]="1"
							/>
		}

		@if (!$any(input).oldVersion) {
			<label class="input-label" [for]="DateTimePicker.inputId">{{ fieldLabel }}</label>
						<stages-date-time-picker
				#DateTimePicker
							[formControlName]="input.key"
							[placeholder]="input.placeholderKey ? (input.placeholderKey | translate) : ''"
				[ariaLabel]="fieldLabel"
							[setDate]="$any(input.value)"
							[initialHoursOffset]="$any(input).initialHoursOffset"
							[isDateTimeDisabled]="!!input.disabled"
						></stages-date-time-picker>
					}
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									@switch (error) {
										@case ("required") {
											<div class="error" [translate]="'input.required'" role="alert"></div>
										}
										@default {
											<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
										}
									}
								}
							</div>
						}
						@if (input.infoMsgKey && !hasErrors(formControl)) {
							<div class="info-message" [translate]="input.infoMsgKey"></div>
						}
					</div>
				</div>
			}
			@case ("time") {
				<div>
					<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
					<input
						stagesTrim
						[id]="input.key"
						[type]="'time'"
						[attr.step]="1"
						[class]="'text fullsize'"
						[formControlName]="input.key"
						[placeholder]="input.placeholderKey ? (input.placeholderKey | translate) : ''"
						[name]="input.key + 'enabled'"
						(change)="onValueChange(input)"
					/>
					<div class="info">
						@if (hasErrors(formControl) && (formControl.dirty || formControl.touched)) {
							<div>
								@for (error of getErrors(); track error) {
									@switch (error) {
										@case ("required") {
											<div class="error" [translate]="'input.required'" role="alert"></div>
										}
										@default {
											<div class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
										}
									}
								}
							</div>
						}
						@if (input.infoMsgKey && !hasErrors(formControl)) {
							<div class="info-message" [translate]="input.infoMsgKey"></div>
						}
					</div>
				</div>
			}
		}
	</div>
}
